module.exports = __webpack_public_path__ + "static/raidguild__icon-99f5f528d1ddb7185ba89e3a00768318.png";